import axios from 'axios'
import moment from 'moment'
import {FC, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {financialDocsSelector, setFilter, resetFilter} from '../../../redux/slices/financialDocsSlices'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import { hasFilterProps } from './helpers'

interface ButtonGroupsProps {
  hasExport?: boolean
  hasCreate?: boolean
  onResetFilter: () => void
}

export const ButtonGroups: FC<ButtonGroupsProps> = (props) => {
  const {t} = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useAppDispatch()
  const {filter} = useAppSelector(financialDocsSelector)

  const handlePageSizeChange = (per_page: number | undefined | null) => {
    dispatch(setFilter({...filter, per_page: per_page ?? 5}))
  }

  /**
   * Handler untuk export data financial documents ke excel
   */
  const handleExport = async () => {
    setIsLoading(true)

    const token = localStorage.getItem('token')
    const credentials = localStorage.getItem('credential')
    const params = {...filter, credentials}

    try {
      const res = await axios({
        url: `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/findoc/export`,
        method: 'GET',
        params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })

      const href = URL.createObjectURL(res.data)
      const dateNow = moment(new Date()).format('DD-MM-YYYY')
      const link = document.createElement('a')

      link.href = href
      link.setAttribute('download', `PI_Findoc_${dateNow}.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    } catch {
      swal({title: t('Export Failed'), icon: 'error'})
    } finally {
      setIsLoading(false)
    }
  }

  const handleResetFilter = () => {
    dispatch(resetFilter())
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-findoc-filter') as string)
      if(hasFilterProps(persisted)){
        return persisted
      }

      return null
    }catch(e){ return null }
  }

  return (
    <StyledButtonGroups
      leftContent={
        <>
          <SelectPageSize initialValue={25} onChange={(value: any) => handlePageSizeChange(value?.value)} />

          { hasFilter() && <button type="button" onClick={() => handleResetFilter()} className="btn btn-outline-danger btn-sm">Clear Filter</button> }
        </>
      }
      rightContent={
        <>
          {props.hasCreate && (
            <Link
              to='/financial/create'
              className='btn btn-primary d-flex align-items-center me-4'
              title={t('findoc_baru')}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              <p>{t('order-tambah')}</p>
            </Link>
          )}

          {props.hasExport && (
            <button className='btn btn-primary' onClick={handleExport} disabled={isLoading}>
              {isLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Unduh')}
            </button>
          )}

          <button className='btn btn-sm btn-primary' onClick={props.onResetFilter}>
            <i className='fas fa-sync-alt' />
          </button>
        </>
      }
    />
  )
}

ButtonGroups.defaultProps = {
  hasExport: false,
  hasCreate: false,
}
